import { render, staticRenderFns } from "./ServiceInsurance.vue?vue&type=template&id=ea31bc46"
import script from "./ServiceInsurance.vue?vue&type=script&lang=js"
export * from "./ServiceInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports